import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const LoanListNav2UI = ({ context, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Underwriting' to='/su/loans' active={page === 'open'} />
      <TabLinkUI label='Disbursed' to='/su/loansDisbursed/nonRetail' active={page === 'disbursed'} />
      <TabLinkUI label='Disbursed-Retail' to='/su/loansDisbursed/retail' active={page === 'retail'} />
      <TabLinkUI label='Repaid' to='/su/loansRepaid' active={page === 'repaid'} />
      <TabLinkUI label='Expired' to='/su/loansExpired' active={page === 'expired'} />
      <TabLinkUI label='Rejected' to='/su/loansClosed' active={page === 'closed'} />
      {/* <TabLinkUI label='STP' to='/su/loans/stp' active={page === 'stp'} /> */}
    </div>
    <div className='g_m_top_50' />
  </div>

export default LoanListNav2UI
